import { FunctionComponent } from "react";
import { useTranslation } from "../../TranslationContext";
import { IconCheck } from "@tabler/icons-react";
import oekotex from "../../assets/svg/oekotex.svg";

const OekoTex: FunctionComponent = () => {
  const translations = useTranslation();
  return (
    <div
      id="OekoTex"
      className="w-full relative bg-white overflow-hidden flex flex-col items-center justify-start py-10 px-10 box-border text-center text-4xl md:text-3xl text-nebula-950 font-text-base-font-medium lg:px-20 md:py-16 md:px-10 sm:px-6 pb-20"
    >
      <div className="w-full flex flex-col items-center justify-start gap-16 max-w-[1280px]">
        <div className="self-stretch flex items-center gap-24 lg:flex-col md:gap-12">
          <img className="relative w-64 h-64 md:w-48 md:h-48" alt="" src={oekotex} />
          <div className="flex-1 flex flex-col items-center justify-center gap-6">
            <div className="self-stretch flex flex-col items-start gap-2">
              <div className="self-stretch relative tracking-[-0.01em] leading-[125%] font-extrabold">{translations.oekotex.title}</div>
              <div className="self-stretch relative text-xl md:text-lg leading-[125%] text-slate-600">{translations.oekotex.description}</div>
            </div>
            <div className="self-stretch flex flex-col items-start gap-1 text-base md:text-sm text-black text-left">
              <div className="self-stretch flex items-center gap-2 justify-start">
                <IconCheck size={36} className="text-fuchsia-600 shrink-0" />
                <div className="relative leading-[150%]">{translations.oekotex.items.cert}</div>
              </div>
              <div className="self-stretch flex items-center gap-2 justify-start">
                <IconCheck size={36} className="text-fuchsia-600 shrink-0" />
                <div className="relative leading-[150%]">
                  <span>{translations.oekotex.items.testex.prefix}</span>
                  <b>{translations.oekotex.items.testex.bold1}</b>
                  <span>{translations.oekotex.items.testex.middle}</span>
                  <b>{translations.oekotex.items.testex.bold2}</b>
                </div>
              </div>
              <div className="self-stretch flex items-center gap-2 justify-start  ">
                <IconCheck size={36} className="text-fuchsia-600 shrink-0" />
                <div className="relative leading-[150%]">
                  <span>{translations.oekotex.items.zdhc.prefix}</span>
                  <b>{translations.oekotex.items.zdhc.bold}</b>
                </div>
              </div>
              <div className="self-stretch flex items-center gap-2 justify-start">
                <IconCheck size={36} className="text-fuchsia-600 shrink-0" />
                <div className="relative leading-[150%]">
                  <span>{translations.oekotex.items.safe.prefix}</span>
                  <b>{translations.oekotex.items.safe.bold}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OekoTex;
